// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WhBq","colBig":"styles_colBig__2Os6O","colSmall":"styles_colSmall__3hBtV"};